export enum SearchPrefixType {
  TITLE = 'Title: ',
  AUTHOR = '@',
  SUBJECT = 'Subject: ',
  CLIENT = 'Client: ',
  NUMBER = '#',
  MATTER = 'Matter: ',
}
